/** Filas MSP — enfermedad periodontal, mal oclusión (Angle), fluorosis */

export const MSP_COL_ENFERMEDAD_PERIODONTAL = [
  { value: 'leve', label: 'LEVE' },
  { value: 'moderada', label: 'MODERADA' },
  { value: 'severa', label: 'SEVERA' },
];

export const MSP_COL_MALOCLUSION_ANGLE = [
  { value: 'angle_i', label: 'ANGLE I' },
  { value: 'angle_ii', label: 'ANGLE II' },
  { value: 'angle_iii', label: 'ANGLE III' },
];

export const MSP_COL_FLUOROSIS = [
  { value: 'leve', label: 'LEVE' },
  { value: 'moderada', label: 'MODERADA' },
  { value: 'severa', label: 'SEVERA' },
];

export const MSP_INDICADORES_COLUMNAS = [
  {
    field: 'enfermedadPeriodontal',
    title: 'Enfermedad periodontal',
    theme: 'periodontal',
    icon: 'bi-heart-pulse-fill',
    rows: MSP_COL_ENFERMEDAD_PERIODONTAL,
  },
  {
    field: 'angleClasificacion',
    title: 'Mal oclusión',
    theme: 'angle',
    icon: 'bi-diagram-3-fill',
    rows: MSP_COL_MALOCLUSION_ANGLE,
  },
  {
    field: 'fluorosis',
    title: 'Fluorosis',
    theme: 'fluorosis',
    icon: 'bi-droplet-half',
    rows: MSP_COL_FLUOROSIS,
  },
];

/** Clase CSS de nivel / tipo de fila (colores LEVE · MODERADA · SEVERA / ANGLE I–III). */
export function indicadorRowLevelClass(rowValue) {
  if (!rowValue) return '';
  if (rowValue.startsWith('angle_')) {
    return `msp-ind-row--${rowValue.replace(/_/g, '-')}`;
  }
  return `msp-ind-row--level-${rowValue}`;
}

/** Valores legacy que no aparecen en la tabla MSP (sin selección). */
const LEGACY_EMPTY = new Set([
  '',
  'sin_enfermedad',
  'sin_maloclusion',
  'sin_fluorosis',
]);

export function normalizeIndicadorColValue(field, value) {
  const v = (value || '').trim();
  if (LEGACY_EMPTY.has(v)) return '';
  const col = MSP_INDICADORES_COLUMNAS.find((c) => c.field === field);
  if (!col) return v;
  return col.rows.some((r) => r.value === v) ? v : '';
}

export function getIndicadorColLabel(field, value) {
  const v = normalizeIndicadorColValue(field, value);
  if (!v) return '';
  const col = MSP_INDICADORES_COLUMNAS.find((c) => c.field === field);
  const row = col?.rows.find((r) => r.value === v);
  return row ? row.label : v;
}
